import React from 'react'
import { Collapse, NavItem } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import className from 'classnames'
import { Tooltip } from 'antd'

class SidebarItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            collapse: false,
            distanceToTop: null
        }
        this.toggle = this.toggle.bind(this)
        this.myElementRef = React.createRef()
    }

    componentDidMount() {
        this.loadStateFromProps()
    }

    calculateDistanceToTop = () => {
        const element = this.myElementRef.current

        if (element) {
            const rect = element.getBoundingClientRect()
            const distanceToTop = rect.top

            this.setState({ distanceToTop })
        }
    }

    handleMouseEnter() {
        this.calculateDistanceToTop()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.isOpenParent && prevProps.isOpenParent) {
            this.setState({ collapse: false })
        }
    }

    loadStateFromProps = () => {
        this.setState({
            collapse: this.isOpenCollapse(this.props.data)
        })
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }))
    }

    activeRoute = (route) => {
        if (!route.path || typeof route.path !== 'string') return false

        const trimRightPath = route.path.trim().replace(/\/+$/gm, '')
        const currentPath = this.props.location.pathname

        if (route.exact || trimRightPath.length === currentPath.length) {
            return trimRightPath === currentPath
        }

        return currentPath.startsWith(trimRightPath + '/')
    }

    isOpenCollapse = (routes) => {
        if (!routes.items) return this.activeRoute(routes)
        const itemActive = routes.items.find(item => this.isOpenCollapse(item))

        return !!itemActive
    }

    renderItemHeader = (data) => {
        return (
            <li className="nav-item-header">
                <div className="text-uppercase font-size-xs line-height-xs">{data.name}</div>
                <i className="icon-menu" title={data.name} />
            </li>
        )
    }

    renderItemComponent = (data, total, totalTooltip) => {
        return (
            <NavItem>
                {
                    data.name !== 'Thống kê item lỗi QC' && data.name !== 'Statics Overview' && data.name !== 'Báo cáo chi tiết' && this.props.isCollapsed ?
                        <>
                            <Tooltip placement="right" title={data.name}>
                                <NavLink to={data.path} className='nav-link' exact={data.exact}>
                                    {data.icon}
                                    <span>{data.name}</span>
                                </NavLink>
                            </Tooltip>
                            {!!total && (totalTooltip ?
                                <Tooltip placement={'right'} title={totalTooltip}>
                                    <span className='NumberPending'>{total}</span>
                                </Tooltip> :
                                <span className='NumberPending'>{total}</span>
                            )}
                        </> :
                        <NavLink to={data.path} className='nav-link' exact={data.exact}>
                            {data.icon}
                            <span>{data.name}</span>
                            {!!total && (totalTooltip ?
                                <Tooltip placement={'right'} title={totalTooltip}>
                                    <span className='NumberPending'>{total}</span>
                                </Tooltip> :
                                <span className='NumberPending'>{total}</span>
                            )}
                        </NavLink>
                }
            </NavItem>
        )
    }

    render() {
        const { data, total, isCollapsed, totalTooltip, ...rest } = this.props
        if (data.component) return this.renderItemComponent(data, total, totalTooltip)
        if (data.header) return this.renderItemHeader(data)
        if (data.items) {
            const submenuClasses = className({
                'nav-item-submenu': true,
                // 'nav-item-expanded': this.state.collapse,
                // 'nav-item-open': this.state.collapse
            })
            const isActive = !!this.props.location.pathname && (this.props.location.pathname === '/items-mark-error' || this.props.location.pathname === '/static-overview' || this.props.location.pathname === '/users-statics-detail')
            return <NavItem className={submenuClasses} onMouseEnter={() => this.handleMouseEnter()}>
                {
                    data.name !== "Report" ?
                        <Tooltip placement="top" title={isCollapsed ? data.name : ""}>
                            <NavLink className='nav-link' to={data.path} onClick={this.toggle}>
                                {data.icon}
                                <span>{data.name}</span>
                            </NavLink>
                        </Tooltip>
                        :
                        <Tooltip placement="top" title={isCollapsed ? data.name : ""}>
                            <div className={`nav-link cursor-pointer ${isActive ? 'active' : ''}`} ref={this.myElementRef}>
                                {data.icon}
                                <span>{data.name}</span>
                            </div>
                        </Tooltip>
                }
                <Collapse isOpen={this.state.collapse} tag='ul' className='nav nav-group-sub' style={{ top: this.state.distanceToTop }}>
                    {
                        data.items.map((item, key) => {
                            return <SidebarItem {...rest} key={key} data={item} isOpenParent={this.state.collapse} />
                        })
                    }
                </Collapse>
            </NavItem>
        }

        return null
    }
}

export default SidebarItem